import React from 'react';
import Modal from 'components/Modal'
import { toJalali } from "lib/helpers";
import {useCore} from 'store/core'
// components

export default function Delete(props) {


    const core=useCore();
    if(!props.item)
    {
        return null;
    }
    return (
        <>
            <Modal show={!!props.item} handleClose={props.close} title={props.title}>
                <div className="modal-body gap-y-3" style={{fontSize:"14px"}}>
                    <h4 className='text-center'>اطلاعات خرید</h4>
                    <table className="table">
                                    <tr>
                                        <th>شماره فاکتور : {props.item.id}</th>
                                        <th>تاریخ  و ساعت  : {toJalali(props.item.created_at, "jYYYY-jMM-jDD hh:mm")}</th>
                                    </tr>
                                   
                    </table>
                    <table class="table">
                                    <tr>
                                        <th colspan="4">نام مشتری : {props.item.user.complete_name}</th> 
                                    </tr>

                                    <tr>
                                        
                                        <th colspan="2">روش تحویل : {props.item.delivery.name}</th>
                                        <th colspan="2">تحویل به : {props.item.address.title}</th>
                                        <th colspan="2">کد پستی : {props.item.address.postal_code}</th>
                                        
                                    </tr>
                                    <tr>
                                        <th colspan="2">نام تحویل گیرنده بسته : {props.item.address.receiver_name}</th>
                                        <th colspan="2">شماره تحویل گیرنده : {props.item.address.receiver_phone_number}</th>
                                        <th colspan="5">{props.item.address.address_text}</th>
                                       
                                    </tr>
                                </table>


                                <table class="table" style={{fontSize:"12px"}}>
                                <thead>
                                <tr>
                                    <th colspan="10"> <h4 class="text-center">لیست اقلام</h4></th>
                                </tr>
                                <tr>
                                    <th scope="col">ردیف</th>
                                    <th scope="col"> شناسه محصول </th>
                                    <th scope="col"> نام محصول </th>
                                    <th scope="col">مبلغ واحد (تومان)</th>
                                    <th scope="col">تعداد</th>
                                    <th scope="col">مبلغ کل (تومان)</th>
                                </tr>
                                </thead>
                                <tbody>
                               {props.item.items.length>0&& props.item.items.map((oi,index)=>(
                                    <tr>
                                        <th scope="row">{index+1}</th>
                                        <td>{oi.product_id}</td>
                                        <td>{oi.product_name}</td>
                                        <td>{oi.amount}</td>
                                        <td>{oi.count}</td>
                                        <td>{oi.total_amount}</td>
                                    </tr>
                                ))}
                                    
                                </tbody>
                            </table>
                </div>
                <div className="modal-footer flex justify-between">
                    <button className="btn btn-warning w-32" type="button" onClick={()=>{
                        core.dispatch(core.printInvoice(props.item.id,(blob)=>{
                            window.open(blob);
                        }));
                    }}>
                        چاپ فاکتور
                    </button>
                    
                    <button type="button" onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">
                        بستن
                    </button>
                </div>
            </Modal>
        </>
    );
}
